import React, { useState, useEffect, useRef } from 'react';

const OverlayDemo = (props) => {
   

    return (
        <div className="grid">
        <div className="col-12 md:col-16">
             <div className='card'>
                 <h5 style={{marginLeft:500}}>Site Yapısı</h5>

                
             </div>
             
                     
         </div>
     </div>
    )
}

const comparisonFn = function (prevProps, nextProps) {
    return prevProps.location.pathname === nextProps.location.pathname;
};

export default React.memo(OverlayDemo, comparisonFn);